import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditIncomingServer = mutatorAction('updateEditIncomingServer', function (server) {
    var store = connectedAccountsStore();
    store.editAccountState.incomingServer = server;
});
//# sourceMappingURL=updateEditIncomingServer.js.map